export default __webpack_public_path__ + "static/media/Senators.32ddaa7c.png";